import React from 'react'
import PropTypes from 'prop-types'

const CloseButtonComponent = ({ onClick }) => {
  return (
    <div className="circle_button_div">
      <button className="circle_button" onClick={onClick}></button>
    </div>
  )
}

CloseButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default CloseButtonComponent
